//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
import "../Facet/Facet.SelectFacetedBody.js";
import "../no/SelectObject.js";
let d=[[[0,"DistanceTolerance",1,0],[1,"FacetBodyOne",0,"Facet.SelectFacetedBody",0],[1,"FacetBodyTwo",0,"Facet.SelectFacetedBody",0],[0,"InputStatus",1,0],[0,"Smoothness",1,0],[0,"Vertex1Range1",1,"Point",0],[0,"Vertex1Range2",1,"Point",0],[0,"Vertex2Range1",1,"Point",0],[0,"Vertex2Range2",1,"Point",0]],[[[],"FlipRange1",{},0,0],[[],"FlipRange2",{},0,0]],[]];
SPLM.Facet.BridgeFacetBodyBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.BridgeFacetBodyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Facet.BridgeFacetBodyBuilder.SmoothTypes = Object.freeze({
    "Linear" : "Linear", "TangentBased" : "TangentBased"});

SPLM.Facet.BridgeFacetBodyBuilder.Input = Object.freeze({
    "Keep" : "Keep", "Delete" : "Delete", "Hide" : "Hide"});

export default SPLM;